import { get } from 'lodash';

import Constants from '@/utils/constants';

export const selectMerchantType = (state) =>
	get(state, 'merchantProfile.merchantDetails.type');

export const selectMerchantId = (state) =>
	get(state, 'merchantProfile.merchantDetails.merchantId');

export const selectBusinessUnit = (state) =>
	get(state, 'merchantProfile.merchantDetails.businessUnit');

export const selectChimeraConfig = (state) =>
	get(state, 'userConfig.chimeraConfig.data', {});

export const selectMerchantTypeAttribute = (state, { ONLINE, OFFLINE }) => {
	const merchantType = selectMerchantType(state);

	switch (merchantType) {
		case Constants.ONLINE_MERCHANT:
			return ONLINE;
		case Constants.OFFLINE_MERCHANT:
			return OFFLINE;
		default:
			return OFFLINE;
	}
};
